/**
 * Created by elan on 2018/6/12.
 */
var common = {
  level: function(level) {
    var levelText = [
      '预备代理',
      '正式代理',
      '铜牌代理',
      '银牌代理',
      '金牌代理',
      '钻石代理',
      '星耀代理'
    ][level]
    return levelText
  },
  levelNum: function(levelText) {
    var level = ''
    switch (levelText) {
      case '预备代理':
        level = 0
        break
      case '正式代理':
        level = 1
        break
      case '铜牌代理':
        level = 2
        break
      case '银牌代理':
        level = 3
        break
      case '金牌代理':
        level = 4
        break
      case '钻石代理':
        level = 5
        break
      case '星耀代理':
        level = 6
        break
    }
    return level
  },
  download: function(env) {
    return (
      'https://cdn.shrongyikejis.com/protocol/' +
      env.replace('-test', '') +
      '/download/download.html'
    )
  },
  host: function() {
    return (
      window.location.protocol +
      '//' +
      localStorage.getItem('env') +
      '-member.shrongyikeji.com'
    )
  },
  /*-------------------------
   验证手机号
   ---------------------------*/
  isValidMobileNum: function(obj) {
    return /^1[0-9][0-9]{9}$/.test(obj)
  },
  /*-------------------------
   验证是否为正整数
   ---------------------------*/
  isInt: function(num) {
    return /^[0-9]*[1-9][0-9]*$/.test(num)
  },
  /*-------------------------
   验证0或正整数
   ---------------------------*/
  isIntSpe: function(num) {
    return /^\d$|^[1-9]\d*$/.test(num)
  },
  /*-------------------------
   验证身份证
   ---------------------------*/
  isValidIdentityNum: function(obj) {
    return /(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(obj)
  },
  /*-------------------------
   验证邮箱
   ---------------------------*/
  isValidEmail: function(obj) {
    return /^(\w)+(\.\w+)*@(\w)+((\.\w{2,3}){1,3})$/.test(obj)
  },
  /*-------------------------
   验证空字符串
   ---------------------------*/
  isStrNotEmpty: function(obj) {
    return (
      typeof obj != 'undefined' &&
      obj != null &&
      obj.toString().replace(/^\s+|\s+$/g, '') != ''
    )
  },

  /*-------------------------
   去除空格
   ---------------------------*/
  tirm: function(val) {
    var reg = /\s/g
    return val.replace(reg, '')
  },
  /*-------------------------
   验证空对象
   ---------------------------*/
  isEmptyObject: function(obj) {
    for (var key in obj) {
      return false
    }
    return true
  },
  /*-------------------------
   获取链接后所有参数
   ---------------------------*/
  allParams: function() {
    var string_a = window.location.href.split('?')
    if (string_a.length > 1) {
      var string = string_a[1].split('&')
      var res = {}
      for (var i = 0; i < string.length; i++) {
        var str = string[i].split('=')
        res[str[0]] = str[1]
      }
      console.log(res)
      return res
    } else {
      console.log('没有参数')
    }
  },
  /*-------------------------
   获取链接后所有参数 组装成一个对象
   ---------------------------*/
  parames: function() {
    var str = window.location.href.split('?')[1]
    var arr = str.split('&')
    var params = {}
    for (var i = 0; i < arr.length; i++) {
      var v = arr[i].split('=')
      if (v[0] == 'state') {
        continue
      }
      params[v[0]] = v[1]
    }
    return params
  },
  /*------------
   接受格式化参数的时间格式化 
   -----------*/
  formatDataExp: function(date, format) {
    if (!format) format = 'yyyy-MM-dd hh:mm:ss'
    var date = new Date(date);
    var millisecond = date.getMilliseconds()
    if (millisecond < 10) {
      millisecond = '00' + millisecond
    } else if (millisecond < 100) {
      millisecond = '0' + millisecond
    }
    var o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      'S+': millisecond
    }
    if (/(y+)/.test(format)) {
      format = format.replace(
        RegExp.$1,
        (date.getFullYear() + '').substr(4 - RegExp.$1.length)
      )
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(format)) {
        format = format.replace(
          RegExp.$1,
          RegExp.$1.length == 1
            ? o[k]
            : ('00' + o[k]).substr(('' + o[k]).length)
        )
      }
    }
    return format
  },
  /*-------------------------
   时间戳格式化
   ---------------------------*/
  formatDate: function(dateStr) {
    if (dateStr === null || dateStr === 'null') {
      return 'null'
    } else {
      var now = new Date(dateStr)
      var year = now.getFullYear(),
        month = now.getMonth() + 1,
        date = now.getDate(),
        hour = now.getHours(),
        minute = now.getMinutes(),
        second = now.getSeconds()
      month = month < 10 ? '0' + month : month
      date = date < 10 ? '0' + date : date
      hour = hour < 10 ? '0' + hour : hour
      minute = minute < 10 ? '0' + minute : minute
      second = second < 10 ? '0' + second : second
      return (
        year +
        '/' +
        month +
        '/' +
        date +
        ' ' +
        hour +
        ':' +
        minute +
        ':' +
        second
      )
    }
  },
  /*-------------------------
   获取时间戳兼容safari iphone
   ---------------------------*/
  getTimeStamp: function(str) {
    if (str == '') {
      return ''
    } else {
      var arr = str.toString().split(/[- : \/]/)
      var date = new Date(
        arr[0],
        arr[1] - 1,
        arr[2],
        arr[3] | '00',
        arr[4] | '00',
        arr[5] | '00'
      ).getTime()
      return date
    }
  },
  /*-------------------------
   浏览器环境
   ---------------------------*/
  browser: {
    versions: (function() {
      var u = navigator.userAgent,
        app = navigator.appVersion
      return {
        trident: u.indexOf('Trident') > -1, //IE内核
        presto: u.indexOf('Presto') > -1, //opera内核
        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, //是否iPad
        webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
        weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
        qq: u.match(/\sQQ/i) == ' qq' //是否QQ
      }
    })(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
  }
}

export default {
  common
}



// WEBPACK FOOTER //
// ./src/api/common.js